export default "__VITE_ASSET__BxJXbqKB__"